<app-layout class="container--grey">
  <div class="inner-container">
    <div class="float" (click)="onFloatClick()" (mouseover)="floatHover=true" (mouseleave)="floatHover=false">
      <div class="float-button-body" [ngStyle]="floatHover ? { 'background-color': '#1B4287' } : { 'background-color': '#3E68B2'}">
        <div class="float-button-text paragraph-medium-regular">{{floatHover ? "Click to find the right form" : "Get Started"}}</div>
      </div>
      <img class="overlap-image" src="/assets/images/get-started.svg" alt="unauthorized person">
    </div>
    <div class="row-title-header">
      <ng-container> 
        <div class="row-title-container"> 
          <div class="row-title-content heading-h5-bold">Pre-Procurement Forms</div>
        </div>
      </ng-container>
    </div>
    <div class="row w-100 pe-4 purchase-mode-info-alert" *ngIf="showInfoAlert">
      <shared-alert class="w-100" [type]="alertType.Info" oneTimeOnlyKey="mypurchase_alert_airlines-not-allowed-rfq"
        [oneTimeButtonText]="'Do Not Show Again'">
        <p alert-content class="my-1">
          For air ticket purchases, please directly raise a PO in MMS. <a [href]="getMMSPOUrl()"
            style="color:var(--custom-primary-500)" target="_blank">Launch MMS</a>
        </p>
      </shared-alert>
    </div>
    <div class="sections-container">
      <app-options-section class="section" [optionsList]="purchaseOrder" [imgPath]="purchaseOrderImg" [sectionTitle]="purchaseOrderTitle" [sectionText]="purchaseOrderText"></app-options-section>
      <app-options-section class="section" [optionsList]="contract" [imgPath]="contractImg" [sectionTitle]="contractTitle" [sectionText]="contractText"></app-options-section>
      <app-options-section class="section" [optionsList]="others" [imgPath]="othersImg" [sectionTitle]="othersTitle" [sectionText]="othersText"></app-options-section>
    </div>
  </div>    
</app-layout>
  